import { FC, useEffect, useMemo } from "react";
import { useIntl } from "react-intl";
import { PageTitle, usePageData } from "../../../_metronic/layout/core";
import { TUserRole } from "../../transports/user";
import { useAuth } from "../../utils/useAuth";
import AdminDashboard from "./AdminDashboard";
import ProjectManagerDashboard from "./ProjectManagerDashboard";
import BusinessManagerDashboard from "./BusinessManagerDashboard";
import LinkerDashboard from "./LinkerDashboard/LinkerDashboard";
import WriterDashboard from "./WriterDashboard";
import ProofreaderDashboard from "./ProofreaderDashboard";
import LeadProjectManagerDashboard from "./LeadProjectManagerDashboard";
import LeadBusinessManagerDashboard from "./LeadBusinessManagerDashboard";
import LeadLinkerDashboard from "./LeadLinkerDashboard/LeadLinkerDashboard";
import LeadWriterDashboard from "./LeadWriterDashboard";
import LeadProofreaderDashboard from "./LeadProofreaderDashboard";
import WorkerDashboard from "./WorkerDashboard";
import LeadWorkerDashboard from "./LeadWorkerDashboard";
import { DocumentationModal } from "src/app/components";

const DashboardPage: FC = () => {
    const { currentUser } = useAuth();

    const dashboardLayout: TUserRole | "DEFAULT" | string =
        currentUser?.role != undefined ? currentUser?.role : "DEFAULT";

    return (
        <>
            {
                {
                    ROLE_SUPER_ADMIN: <AdminDashboard />,
                    ROLE_ADMIN: <AdminDashboard />,
                    ROLE_LEAD_PROJECT_MANAGER: <LeadProjectManagerDashboard />,
                    ROLE_LEAD_BUSINESS_MANAGER: <LeadBusinessManagerDashboard />,
                    ROLE_LEAD_LINKER: <LeadLinkerDashboard />,
                    ROLE_LEAD_WRITER: <LeadWriterDashboard />,
                    ROLE_LEAD_PROOFREADER: <LeadProofreaderDashboard />,
                    ROLE_PROJECT_MANAGER: <ProjectManagerDashboard />,
                    ROLE_BUSINESS_MANAGER: <BusinessManagerDashboard />,
                    ROLE_LINKER: <LinkerDashboard />,
                    ROLE_WRITER: <WriterDashboard />,
                    ROLE_PROOFREADER: <ProofreaderDashboard />,
                    ROLE_LEAD_WORKER: <LeadWorkerDashboard />,
                    ROLE_WORKER: <WorkerDashboard />,
                    DEFAULT: <>You're in trouble</>,
                }[dashboardLayout]
            }
        </>
    );
};

const DashboardWrapper: FC = () => {
    const { formatMessage } = useIntl();
    const { currentUser } = useAuth();
    const MemoDocumentationModal = useMemo(
        () => (
            <DocumentationModal
                url={`https://s3.eu-west-1.amazonaws.com/files.digitent.co/videos/dashboard_${currentUser.role}.mp4`}
                title={`Documentation : ${formatMessage({ id: "MENU.DASHBOARD" })}`}
            />
        ),
        []
    );
    const { setPageBreadcrumbs, setPageToolbarButtons, setPageToolbarLinks } = usePageData();
    useEffect(() => {
        setPageBreadcrumbs([]);
        setPageToolbarButtons([]);
        setPageToolbarLinks([]);
    }, []);

    return (
        <>
            <PageTitle leftPageCustomComponent={MemoDocumentationModal}>
                {formatMessage({ id: "MENU.DASHBOARD" })}
            </PageTitle>
            <DashboardPage />
        </>
    );
};

export default DashboardWrapper;
